<template>
    <paper class="warehouse-delegation-letter">
        <MPane ref="tablePage" :config="config" :totalData="totalData" :pageTotal="page.pageTotal" :loading="loading"
            :searchTotalTitle="config.searchTotalTitle" :currentPage="page.pageNo" :initSearchInfo="initSearchInfo"
            searchId="warehouseDelegationLetter" pageID="warehouseDelegationLetter_20251009" @searchChange="searchChange"
            @pageChange="pageChange" @sizeChange="sizeChange" @signDetails-btn="signDetailsBtn"
            @operationRecord-btn="operationRecordBtn" @approvalDetails-btn="approvalDetailsBtn" @btnClick="btnClick"
            @row-db-click="rowDBclick" @edit-btn="rowDBclick" @sensitiveClick="handleSensitive"
            @selectChange="handleSelect">
            <div slot="table-module-btn">
                <el-tooltip effect="dark" content="新增" placement="bottom">
                    <el-button icon="el-icon-plus" size="mini" class="bigData-btn-add" type="primary"
                        @click="handleAdd"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <el-button icon="el-icon-download" size="mini" class="bigData-btn-export" :loading="exportLoading"
                        @click="handleExport"></el-button>
                </el-tooltip>
            </div>
            <div slot="page-module-btn">
                <el-button :loading="btnLoading" class="bigData-btn-signature" type="primary" size="mini" @click="onSignature">
                    发起委派函签署
                </el-button>
                <el-button class="bigData-btn-enable" type="primary" @click="onEnable">
                    启用
                </el-button>
                <el-button class="bigData-btn-stop" type="primary" @click="onStopUsing">
                    停用
                </el-button>
                <el-button class="bigData-btn-authorize" type="primary" size="mini" @click="handleAuthorize">
                    前往授权或签署
                </el-button>
                <el-button v-if="!$store.state.supplier" class="bigData-btn-audit" type="primary" size="mini"
                    @click="handleApprove">
                    批量审批
                </el-button>
                <el-tooltip effect="dark" content="可进行批量新增仓库人员，仅限同一个合同号，切换合同号需重新审核和签署委派函" placement="top-start">
                    <el-button icon="el-icon-question" class="bigData-btn-contract" type="primary" size="mini" @click="editContract">
                    批量切换合同
                    </el-button>
                </el-tooltip>
                <el-button class="bigData-btn-logical-warehouse" type="primary" size="mini"
                    @click="handleEditLogicalWarehouse">
                    修改主工作逻辑仓
                </el-button>
                <el-button type="primary" size="mini" :loading="updateLoading"
                    @click="handleUpdate">
                    更新
                </el-button>
                <el-button v-if="!$store.state.supplier" type="primary" size="mini"
                    @click="handleBlock">
                    拉黑
                </el-button>
            </div>
        </MPane>
        <SignDetailsDialog ref="signDetailsDialog"></SignDetailsDialog>
        <operationRecordDialog ref="operationRecordDialog"></operationRecordDialog>
        <EditContract @refresh="getData" ref="editContract" />
        <EditLogicalWarehouse @refresh="pageChange(1)" ref="editLogicalWarehouse" />
        <!-- <StorageDelegateDialog ref="sddRef" @refresh="getData" /> -->
    </paper>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import { dictWithUrl } from '@/components/lots/api'
import Paper from '@/components/core/paper/Paper'
import MPane from '@/components/supplierPanel'
import SignDetailsDialog from './SignDetailsDialog.vue'
import operationRecordDialog from './operationRecordDialog.vue'
import EditLogicalWarehouse from './EditLogicalWarehouse.vue'
// import StorageDelegateDialog from './StorageDelegateDialog.vue';
import { OPERATE_TYPES, AUDIT_STATUS } from './constant.js'
import config from './config.js'
import { getSensitiveVal } from '../../../utils/common'
import {
    manageSearch,
    supplierWarehouseDelegateSearh,
    postEnable,
    postDisable,
    commissioning,
    lsrmExportWarehouseDelegate,
    lspExportWarehouseDelegate,
    batchApproval,
    supplierWarehouseDelegateRefresh,
} from '../../../api/warehouseResourceManagement/warehouseDelegationLetter.js'
import { getAuthorizationUrl } from '../../../api/signature.js'
import EditContract from './EditContract.vue'

export default {
    name: 'warehouseDelegationLetter',
    components: { Paper, MPane, SignDetailsDialog, operationRecordDialog, EditContract,EditLogicalWarehouse },
    data() {
        return {
            btnLoading: false,
            initSearchInfo: {}, //初始化查询参数
            searchObj: {}, //查询参数
            loading: false,
            page: {
                pageNo: 1,
                pageSize: config.page.pageSize,
                pageTotal: 0,
            },
            importLoading: false,
            exportLoading: false,
            noticeLoading: false,
            updateLoading: false,
            config,
            totalData: [],
            dictData: {},
            selecteList: [],
            OPERATE_TYPES,
        }
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'user']),
    },
    created() {
        this.setConfig()
    },
    mounted() {
        // this.setConfig()
        this.init();
        ['supplierSignStatusList', 'warehouseWorkerSignStatusList', 'auditStatusList'].forEach(item => {
            const val = this.$route.query[item]
            if (val) {
                this.initSearchInfo = { [item]: val.split(',') }
                this.searchObj = { [item]: val.split(',') }
            }
        })
        this.getDicData()

        const { isFlow, id, warehouseDelegateNo } = this.$route.query
        if (isFlow && id && warehouseDelegateNo) {
            // this.$refs.sddRef.open(OPERATE_TYPES.AUDIT, { id, warehouseDelegateNo })
            let path = this.$store.state.supplier ? '/lsrm/warehouseDelegationApprove' : '/warehouseDelegationApprove'
            this.$router.push(`${path}?type=${OPERATE_TYPES.AUDIT}&id=${id}&warehouseDelegateNo=${warehouseDelegateNo}`)
        }
    },
    activated(){
        ['supplierSignStatusList', 'warehouseWorkerSignStatusList', 'auditStatusList'].forEach(item => {
            const val = this.$route.query[item]
            if (val) {
                this.initSearchInfo = { [item]: val.split(',') }
                this.searchObj = { [item]: val.split(',') }
            }
        })
        this.getDicData()
    },
    methods: {
        handleBlock(){
            if(!this.selecteList.length){
                return this.$message.warning('请选择数据')
            }
            if(this.selecteList.length > 1){
                return this.$message.warning('只能选择1条数据')
            }
            if(this.selecteList.some(v => v.blackFlag === '1')){
                return this.$message.warning('请选择是否黑名单=否的数据')
            }
            const {workerName, idCardNo} = this.selecteList[0]
            this.$router.push({
                path: '/addAuback',
                query: {
                    corporateName: workerName, idCard: idCardNo, property: '2', blackSourceType: '1'
                }
            })
        },
        setConfig() {
            if (this.$store.state.supplier) {
                //LSP
                this.config.searchList = { ...config.lspSearch }
                this.config.table = { ...config.lspTable }
            } else {
                //LSRM
                this.config.searchList = { ...config.lsrmSearch }

                this.config.table = { ...config.lsrmTable }
            }
        },
        init() {
            const initSearchInfo = {}
            let startDate = dayjs().subtract(1, 'year').format('YYYY-MM-DD 00:00:00')
            let endDate = dayjs().format('YYYY-MM-DD 23:59:59')
            initSearchInfo.timeRange = [startDate, endDate]
            this.searchObj.timeRange = initSearchInfo.timeRange
            this.initSearchInfo = initSearchInfo
            this.setSupplierAdvanceUrl()
        },
        handleUpdate(){
            if(!this.selecteList.length){
                return this.$message.warning('请选择数据')
            }
            this.updateLoading = true
            supplierWarehouseDelegateRefresh(this.selecteList.map(v => v.warehouseDelegateNo)).then(res => {
                if (res && +res.code === 0) {
                        this.$message.success('更新成功')
                        this.getData()
                    }
            }).finally(() => {
                this.updateLoading = false
            })
        },
        handleEditLogicalWarehouse() {
            if (this.isLegalContractCodeEqual(this.selecteList)) {
                this.$refs['editLogicalWarehouse'].show(this.selecteList)
            } else {
                this.$message.warning('请选择同一个法务合同号的数据!')
            }

        },
        /**
         * 检查对象数组中的所有元素的 legalContractCode 属性是否全等
         * @param {Array} arr - 对象数组
         * @returns {boolean} - 全等返回 true，否则 false
         */
        isLegalContractCodeEqual(arr) {
            if (!Array.isArray(arr) || arr.length === 0) {
                return false; // 空数组或非数组直接返回 false
            }

            const firstCode = arr[0].legalContractCode; // 取第一个元素的 legalContractCode 作为基准
            return arr.every(item => item.legalContractCode === firstCode);
        },
        //列头点击脱敏
        handleSensitive(prop, value) {
            //手机号
            for (const item of this.totalData) {
                if (prop === '_workerPhone') {
                    if (value) {
                        item._workerPhone = item.workerPhone
                    } else {
                        item._workerPhone = getSensitiveVal(item.workerPhone, 'phone')
                    }
                } else if (prop === '_idCardNo') {
                    //身份证号
                    if (value) {
                        item._idCardNo = item.idCardNo
                    } else {
                        item._idCardNo = getSensitiveVal(item.idCardNo, 'idCard')
                    }
                }
            }
        },
        // 动态设置供应商租户参数
        setSupplierAdvanceUrl() {
            const target = this.config.searchList.searchTxt.find(v => v.value === 'suppliersName')
            target &&
                (target.advanceUrl = `/supplier/getSupplierInfosByNameAndCode?tenantCode=${this.currentTenant.tenantCode}`)
        },
        //启用
        onEnable() {
            if (!this.selecteList.length || this.selecteList.length > 1) {
                this.$message.warning('请选择单条数据')
                return
            }
            if (this.selecteList.length) {
                if (!this.$store.state.supplier && !this.selecteList[0].salaryPaydayCode) {
                    return this.$message.warning('该合同的发薪日期为空，请前往发薪日期配置里维护日期')
                }
                // 审批状态=审批通过。供应商签署状态=已签署，仓储人员的签署状态=已签署
                // delegateType ：2 -仓储委派函类型=线下委派函、
                // auditStatus：20 -审批状态=审批通过、
                // supplierSignStatus：1 -供应商签署状态=已签署、
                // warehouseWorkerSignStatus ：1 -仓储人员的签署状态=已签署
                let flag = false
                for (const item of this.selecteList) {
                    if (item.delegateType === '2' && item.auditStatus === '20') {
                        flag = false
                        break
                    }
                    else if (
                        !(
                            item.auditStatus === '20' &&
                            item.supplierSignStatus === '1' &&
                            item.warehouseWorkerSignStatus === '1'
                        )
                    ) {
                        flag = true
                        break
                    }
                }
                if (flag) {
                    this.$message.warning(
                        '请勾选 仓储委派函类型=线上委派函，审批状态=审批通过，供应商签署状态=已签署，仓储人员的签署状态=已签署的数据',
                    )
                    return
                }
            }
            let warehouseDelegateNoList = []
            for (const item of this.selecteList) {
                warehouseDelegateNoList.push(item.warehouseDelegateNo)
            }
            this.loading = true
            postEnable(warehouseDelegateNoList)
                .then(res => {
                    if (res && +res.code === 0) {
                        const successMsg = !!this.$store.state.supplier && !this.selecteList[0].salaryPaydayCode ?
                            '该合同的发薪日期为空，请告知现场人员发薪日期，并联系现场人员维护' : '启用成功'
                        this.$message.success(successMsg)
                        this.page.pageNo = 1
                        this.getData()
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        //停用
        onStopUsing() {
            if (!this.selecteList.length) {
                this.$message.warning('请选择数据')
                return
            }
            if (this.selecteList.length > 1) {
                this.$message.warning('只能选择单条数据')
                return
            }

            let warehouseDelegateNoList = []
            for (const item of this.selecteList) {
                warehouseDelegateNoList.push(item.warehouseDelegateNo)
            }
            this.loading = true
            postDisable(warehouseDelegateNoList)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('停用成功')
                        this.page.pageNo = 1
                        this.getData()
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        //判断选择的数据是不是同一个合同号，供应商签署状态=待发起，委派函类型=线上，仓库人员签署状态=待发起
        //@return ture表示符合、false不符合
        isSameContractNumber(selecteList) {
            let preVal = ''
            let flag = true
            for (const item of selecteList) {
                if (preVal !== '' && preVal !== item.legalContractCode) {
                    flag = false
                    break // 发现不同值
                } else {
                    preVal = item.legalContractCode
                }
                // supplierSignStatus: 2 -供应商签署状态=待发起
                // delegateType:1 -委派函类型=线上，
                //warehouseWorkerSignStatus:2 -仓库人员签署状态=待发起
                if (
                    item.supplierSignStatus !== '2' ||
                    item.delegateType !== '1' ||
                    item.warehouseWorkerSignStatus !== '2'
                ) {
                    flag = false
                    break
                }
            }
            return flag
        },
        //发起委派函签署
        onSignature() {
            if (!this.selecteList.length) {
                this.$message.warning(
                    '请选择相同的合同号，供应商签署状态=待发起，委派函类型=线上，仓库人员签署状态=待发起的数据',
                )
                return
            }
            if (this.selecteList.length > 50) {
                this.$message.warning('允许单条或多条，最多50条数据')
                return
            }
            if (!this.isSameContractNumber(this.selecteList)) {
                this.$message.warning(
                    '同一个合同号，供应商签署状态=待发起，委派函类型=线上，仓库人员签署状态=待发起，才允许发起供应商签署',
                )
                return
            }

            let warehouseDelegateNoList = []
            for (const item of this.selecteList) {
                warehouseDelegateNoList.push(item.warehouseDelegateNo)
            }
            this.btnLoading = true
            commissioning(warehouseDelegateNoList)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('发起委派函签署成功')
                        this.page.pageNo = 1
                        this.getData()
                    }
                })
                .finally(() => {
                    this.btnLoading = false
                })
        },
        editContract() {
            if (!this.selecteList.length) {
                return this.$message.warning('请选择数据')
            }
            if (this.selecteList.some(v => v.auditStatus === AUDIT_STATUS.PENDING)) {
                return this.$message.warning('选中的数据包含审批中状态，无法修改合同号')
            }
            if ([...new Set(this.selecteList.map(v => v.legalContractCode))].length > 1) {
                return this.$message.warning('修改合同需同一个法务合同编码')
            }
            this.$refs['editContract'].init(this.selecteList.map(v => v.warehouseDelegateNo))
        },
        handleApprove() {
            if (!this.selecteList.length) {
                return this.$message.warning('请选择数据')
            }
            if (this.selecteList.length > 20) {
                return this.$message.warning('批量审批数据最多20条')
            }
            const workers = this.selecteList.map(v => v.workerName+'/'+v.warehouseWorkerNo).reduce((t, v) => {
                t += `<div class="worker-item">${v}</div>`
                return t
            }, '')
            this.$confirm(`<div class="worker-wrap">${workers}</div>`, '你确认要批量审批以下仓库人员吗？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                customClass: 'approve-confirm-box',
            }).then(() => {
                batchApproval(this.selecteList.map(v => v.warehouseDelegateNo)).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('操作成功')
                        this.getData()
                    }
                })
            })
        },
        /***
         *  前往授权或签署
         *  **/
        handleAuthorize() {
            getAuthorizationUrl().then(res => {
                if (res && res.code === '0') {
                    window.open(res.data)
                }
            })
        },
        //新增
        handleAdd(data) {
            // this.$refs.sddRef.open(OPERATE_TYPES.ADD)
            let path = this.$store.state.supplier ? '/lsrm/warehouseDelegationApprove' : '/warehouseDelegationApprove'
            this.$router.push(`${path}?type=${OPERATE_TYPES.ADD}`)
        },
        //编辑
        rowDBclick(data) {
            // this.$refs.sddRef.open(OPERATE_TYPES.EDIT, data)
            let path = this.$store.state.supplier ? '/lsrm/warehouseDelegationApprove' : '/warehouseDelegationApprove'
            this.$router.push(`${path}?type=${OPERATE_TYPES.EDIT}&id=${data.id}&warehouseDelegateNo=${data.warehouseDelegateNo}`)
        },
        // 审批详情
        approvalDetailsBtn(data) {
            // this.$refs.sddRef.open(OPERATE_TYPES.AUDIT, data)
            let path = this.$store.state.supplier ? '/lsrm/warehouseDelegationApprove' : '/warehouseDelegationApprove'
            this.$router.push(`${path}?type=${OPERATE_TYPES.AUDIT}&id=${data.id}&warehouseDelegateNo=${data.warehouseDelegateNo}`)
        },
        //签署详情
        signDetailsBtn(data) {
            this.$refs.signDetailsDialog.show(data.warehouseDelegateNo)
        },
        //操作记录
        operationRecordBtn(data) {
            this.$refs.operationRecordDialog.show(data.warehouseDelegateNo)
        },
        btnClick(e, index, row, prop) {
            // const { planFdId, noticeFdId, noticeCode } = row
        },

        /**
         * 判断数组对象的属性值是否一样
         * @param arr
         * @param prop
         * return 反回false 表示属性值都是一样的，true 表示属性值存在不同
         */
        hasDifference(arr, prop) {
            const firstValue = arr[0][prop]
            return arr.some(item => {
                if (item[prop] === '' || item[prop] === null || item[prop] === undefined) {
                    return true
                }
                return item[prop] !== firstValue
            })
        },
        searchChange(data) {
            // 点击查询
            this.page.pageNo = 1
            this.searchObj = data
            this.getData()
        },
        setColSensitive(){
            const idCardNoCol = this.config.table.columns.findIndex(v => v.prop === '_idCardNo')
            const phoneCol = this.config.table.columns.findIndex(v => v.prop === '_workerPhone')
            this.config.table.columns[idCardNoCol].sensitiveValue = true
            this.config.table.columns[phoneCol].sensitiveValue = true
        },
        pageChange(currentPage) {
            // 切换分页页数
            this.setColSensitive()
            this.page.pageNo = currentPage
            this.getData()
        },
        sizeChange(pageSize) {
            // 切换分页显示条数
            this.setColSensitive()
            this.page.pageNo = 1
            this.page.pageSize = pageSize
            this.getData()
        },
        verifyParams() {
            const { timeRange, contractCode } = this.searchObj
            if (!(Array.isArray(timeRange) && timeRange.length > 0) && !contractCode) {
                this.$message.warning('请选择开始时间和结束时间')
                return false
            }
            let startTime = ''
            let endTime = ''
            let duration = 0
            if (Array.isArray(timeRange)) {
                startTime = dayjs(timeRange[0])
                endTime = dayjs(timeRange[1])
                duration = endTime.diff(startTime, 'month')
            }
            // 判断时间范围是否超过3个月
            if (duration > 2) {
                this.$message.warning('时间范围不能超过3个月')
                return false
            }
            return true
        },
        getData() {
            // const flag = this.verifyParams() //校验参数，日期默认7天，最大3个月
            const searchParams = this.handleBeforesearch()
            // if (!flag) {
            //     return
            // }
            const params = { ...searchParams, pageNo: this.page.pageNo, pageSize: this.page.pageSize }
            this.loading = true
            let api = manageSearch
            if (this.$store.state.supplier) {
                //LSP
                api = supplierWarehouseDelegateSearh
            }
            api(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        let dataList = []
                        const { list, totalCount } = res.data
                        this.page.pageTotal = totalCount
                        if (Array.isArray(list) && list.length) {
                            dataList = this.conversionData(list)
                        }
                        this.totalData = dataList
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 处理查询条件数据字典排序
        sortList() {
            let newAuditStatusList = []
            let newSigningStatusList = []
            let auditStatusDic = this.dictData.WAREHOUSE_DELEGATE_AUDIT_STATUS
            let signingStatusDic = this.dictData.WAREHOUSE_SIGN_STATUS
            // 审批状态排序
            // 00：'草稿', 01:'新建',80：'撤回','2':待审批,3：'审批中',20：'通过'，40：'废弃'，30：驳回
            let approvalStatusList = ['00', '01', '80', '2', '3', '20', '40', '30']
            // 供应商签署状态、仓库人员签署状态
            // 2：'待发起', 0：'未签署',1：'已签署', 3：'已撤回',-1：'签署失败'
            let signingStatusList = ['2', '0', '1', '3', '-1']
            // 审批状态排序
            for (const item of approvalStatusList) {
                for (const key in auditStatusDic) {
                    if (item === key) {
                        let row = { label: auditStatusDic[key], value: key }
                        newAuditStatusList.push(row)
                    }
                }
            }
            // 供应商签署状态、仓库人员签署状态 排序
            for (const item of signingStatusList) {
                for (const key in signingStatusDic) {
                    if (item === key) {
                        let row = { label: signingStatusDic[key], value: key }
                        newSigningStatusList.push(row)
                    }
                }
            }
            for (const item of this.config.searchList.searchTxt) {
                if (item.value === 'auditStatusList') {
                    item.options = newAuditStatusList
                }
                if (item.value === 'supplierSignStatusList') {
                    item.options = newSigningStatusList
                }
                if (item.value === 'warehouseWorkerSignStatusList') {
                    item.options = newSigningStatusList
                }
            }
        },
        getDicData() {
            //审批状态 auditStatus 字典 WAREHOUSE_DELEGATE_AUDIT_STATUS
            //供应商签署状态 supplierSignStatus 字典： WAREHOUSE_SIGN_STATUS
            //仓库人员签署状态 warehouseWorkerSignStatus 字典 WAREHOUSE_SIGN_STATUS
            //状态 delegateStatus 字典 WAREHOUSE_DELEGATE_STATUS
            //委派函类型 delegateType 字典 WAREHOUSE_DELEGATE_TYPE
            //仓库人员类型 workerType 字典 WAREHOUSE_WORKER_TYPE
            //是否黑名单 blackFlag 字典 SYS_SUPPLIER_YES_NO
            //业务类型(合同) businessType 字典 WAREHOUSE_DELEGATE_BUSINESS_TYPE
            //停用原因 discontinueReason 字典 DISCONTINUE_REASON
            // 发薪日期配置 salaryPaydayCode 字典 SALARY_PAYDAY

            dictWithUrl(
                'WAREHOUSE_DELEGATE_AUDIT_STATUS,WAREHOUSE_SIGN_STATUS,WAREHOUSE_DELEGATE_STATUS,WAREHOUSE_DELEGATE_TYPE,WAREHOUSE_WORKER_TYPE,SYS_SUPPLIER_YES_NO,WAREHOUSE_DELEGATE_BUSINESS_TYPE,DISCONTINUE_REASON,SALARY_PAYDAY,BUSINESS_SCENE',
            ).then(res => {
                this.dictData = res.data

                this.getData()
                this.$nextTick(() => {
                    this.sortList()
                })
            })
        },
        //查询是否需要脱敏
        isSensitiveValue(prop) {
            let sensitiveValue = false
            for (const item of this.config.table.columns) {
                if (item.prop === prop) {
                    sensitiveValue = item.sensitiveValue
                    break
                }
            }
            return sensitiveValue
        },
        conversionData(list) {
            let isWorkerPhone = this.isSensitiveValue('_workerPhone')
            let isIdCardNo = this.isSensitiveValue('_idCardNo')
            for (const item of list) {
                item._createTime = item.createTime
                item._updateTime = item.updateTime
                item._auditStatus = this.dictData.WAREHOUSE_DELEGATE_AUDIT_STATUS[item.auditStatus] //审批状态 auditStatus 字典 WAREHOUSE_DELEGATE_AUDIT_STATUS
                item._supplierSignStatus = this.dictData.WAREHOUSE_SIGN_STATUS[item.supplierSignStatus] //供应商签署状态 supplierSignStatus 字典： WAREHOUSE_SIGN_STATUS
                item._warehouseWorkerSignStatus = this.dictData.WAREHOUSE_SIGN_STATUS[item.warehouseWorkerSignStatus] //仓库人员签署状态 warehouseWorkerSignStatus 字典 WAREHOUSE_SIGN_STATUS
                item._delegateStatus = this.dictData.WAREHOUSE_DELEGATE_STATUS[item.delegateStatus] //状态 delegateStatus 字典 WAREHOUSE_DELEGATE_STATUS
                item._delegateType = this.dictData.WAREHOUSE_DELEGATE_TYPE[item.delegateType] //委派函类型 delegateType 字典 WAREHOUSE_DELEGATE_TYPE
                item._workerType = this.dictData.WAREHOUSE_WORKER_TYPE[item.workerType] //仓库人员类型 workerType 字典 WAREHOUSE_WORKER_TYPE
                item._blackFlag = this.dictData.SYS_SUPPLIER_YES_NO[item.blackFlag] //是否黑名单 blackFlag 字典 SYS_SUPPLIER_YES_NO
                item._businessType = this.dictData.WAREHOUSE_DELEGATE_BUSINESS_TYPE[item.businessType] //业务类型(合同) businessType 字典 WAREHOUSE_DELEGATE_BUSINESS_TYPE
                item._discontinueReason = this.dictData.DISCONTINUE_REASON[item.discontinueReason] //停用原因 discontinueReason 字典 DISCONTINUE_REASON
                item._salaryPaydayCode = this.dictData.SALARY_PAYDAY[item.salaryPaydayCode] //发薪日期配置 salaryPaydayCode 字典 SALARY_PAYDAY
                item._businessScene = item.businessScene
                                ? item.businessScene.split(',').map(v => this.dictData['BUSINESS_SCENE'][v]) +
                                  ''
                                : ''
                if (isWorkerPhone) {
                    item._workerPhone = getSensitiveVal(item.workerPhone, 'phone') //手机号码
                } else {
                    item._workerPhone = item.workerPhone //手机号码
                }
                if (isIdCardNo) {
                    item._idCardNo = getSensitiveVal(item.idCardNo, 'idCard') //身份证号
                } else {
                    item._idCardNo = item.idCardNo //身份证号
                }
            }
            return list
        },
        // 处理请求参数
        handleBeforesearch() {
            const params = cloneDeep(this.searchObj)
            let suppliersCode = params.suppliersCode
            let suppliersName = params.suppliersName
            let workerType = params.workerType
            let supplierList = params.supplierSignStatusList
            let warehouseList = params.warehouseWorkerSignStatusList
            params.workerTypeList = []
            if (!params.companyCode) {
                params.companyCode = ''
            }
            if (!params.salaryPaydayCodeList) {
                params.salaryPaydayCodeList = []
            }
            if (!params.businessSceneList) {
                params.businessSceneList = []
            }
            if (params.customerCode) {
                params.customerCodeList = params.customerCode.split(',')
                delete params.customerCode
                delete params.customerName
            }
            if (params.timeRange && params.timeRange.length) {
                params.startTime = dayjs(params.timeRange[0]).format('YYYY-MM-DD HH:mm:ss')
                params.endTime = dayjs(params.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            if (suppliersCode && suppliersName) {
                params.supplierCodeList = [suppliersCode]
            }
            if (Array.isArray(workerType) && workerType.length) {
                let newWorkerTypeList = []
                for (const item of workerType) {
                    newWorkerTypeList.push(item)
                }
                params.workerTypeList = newWorkerTypeList
            }
            //供应商签署状态
            if (supplierList === '' || supplierList === null || supplierList === undefined) {
                params.supplierSignStatusList = []
            } else if (!Array.isArray(supplierList)) {
                params.supplierSignStatusList = [supplierList]
            }
            //仓库人员签署状态
            if (warehouseList === '' || warehouseList === null || warehouseList === undefined) {
                params.warehouseWorkerSignStatusList = []
            } else if (!Array.isArray(warehouseList)) {
                params.warehouseWorkerSignStatusList = [warehouseList]
            }

            // if (this.$store.state.supplier) {
            //     //LSP
            let auditStatusList = params.auditStatusList
            if (auditStatusList === '' || auditStatusList === null || auditStatusList === undefined) {
                params.auditStatusList = []
            } else if (!Array.isArray(auditStatusList)) {
                params.auditStatusList = [auditStatusList]
            }
            // }

            this.searchObj = cloneDeep(params)

            this.searchObj.timeRange = params.timeRange
            delete params.warehouseName
            delete params.siteName
            delete params.companyName
            delete params.timeRange
            return params
        },
        handleExport() {
            // const flag = this.verifyParams() //校验参数，日期默认7天，最大3个月
            let searchParams = this.handleBeforesearch()

            this.exportLoading = true
            let exportApi = lsrmExportWarehouseDelegate
            if (this.$store.state.supplier) {
                //LSP
                exportApi = lspExportWarehouseDelegate
            }
            exportApi({ ...searchParams })
                .then(res => {
                    if (res && +res.code === 0) {
                        const { downUrl, localFileName } = res.data
                        const a = document.createElement('a')
                        a.style.display = 'none'
                        a.download = `${localFileName}.xlsx`
                        a.href = downUrl
                        a.click()
                        this.$message.success('导出成功')
                    }
                })
                .finally(() => {
                    this.exportLoading = false
                })
        },
        handleSelect(val) {
            this.selecteList = val
        },
    },
}
</script>
<style lang="less">
.warehouse-delegation-letter {
    min-width: 1100px;

    #mPane3 {
        display: flex;
        height: 100%;
        flex-direction: column;

        .select-btn-box {
            margin-bottom: 10px;
        }

        .otp-table {
            flex: 1;
        }

        .el-table {
            min-height: initial;
        }

        .page-text {
            >div {
                height: auto;
            }
        }
    }

    .row-bg {
        .el-col-12 {
            width: 45%;
            // width: calc(100% - 850px);
        }

        .page-text {
            &.el-col-12 {
                width: 55%;

                div:first-child {
                    width: 96px;
                }

                div:last-child {
                    margin-right: 140px !important;

                    .el-button {
                        margin-bottom: 5px;
                        // border: 1px solid red;
                    }
                }

                // width: 840px !important;
            }
        }
    }
    
}

.approve-confirm-box{
    width: 600px;

    .worker-wrap{
        display: flex;
        flex-wrap: wrap;

        .worker-item{
            width: 33%;
            text-align: left;
        }
    }
}

@media screen and (min-width: 1770px) {
    .warehouse-delegation-letter {
        .row-bg {
            .el-col-12 {
                width: 35%;
            }

            .page-text {
                &.el-col-12 {
                    width: 65%;

                    div:last-child {
                        .el-button {
                            margin-bottom: 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>
